/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Readytogrowyourbusinessletsgetstarted7Inputs */

const en_readytogrowyourbusinessletsgetstarted7 = /** @type {(inputs: Readytogrowyourbusinessletsgetstarted7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to grow your business? Let's get started.`)
};

const de_readytogrowyourbusinessletsgetstarted7 = /** @type {(inputs: Readytogrowyourbusinessletsgetstarted7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit, dein Unternehmen wachsen zu lassen? Dann los.`)
};

/**
* | output |
* | --- |
* | "Ready to grow your business? Let's get started." |
*
* @param {Readytogrowyourbusinessletsgetstarted7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const readytogrowyourbusinessletsgetstarted7 = /** @type {((inputs?: Readytogrowyourbusinessletsgetstarted7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Readytogrowyourbusinessletsgetstarted7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_readytogrowyourbusinessletsgetstarted7(inputs)
	return de_readytogrowyourbusinessletsgetstarted7(inputs)
});
export { readytogrowyourbusinessletsgetstarted7 as "readyToGrowYourBusinessLetsGetStarted" }